<mat-accordion multi class="tab-body" togglePosition="before">
  <mat-expansion-panel expanded="true">
    <mat-expansion-panel-header>
      <mat-panel-title>Extended warranty</mat-panel-title>
    </mat-expansion-panel-header>
    <app-extended-warranty
      [prevTab]="prevTab"
      [isReadOnly]="isReadOnly"
    ></app-extended-warranty>
  </mat-expansion-panel>

  <mat-expansion-panel expanded="true">
    <mat-expansion-panel-header>
      <mat-panel-title>Maintenance</mat-panel-title>
    </mat-expansion-panel-header>
    <app-maintenance
      [prevTab]="prevTab"
      [isReadOnly]="isReadOnly"
    ></app-maintenance>
  </mat-expansion-panel>

  <mat-expansion-panel expanded="true">
    <mat-expansion-panel-header>
      <mat-panel-title>Option to purchase</mat-panel-title>
    </mat-expansion-panel-header>
    <app-option-to-purchase
      [prevTab]="prevTab"
      [isReadOnly]="isReadOnly"
    ></app-option-to-purchase>
  </mat-expansion-panel>
</mat-accordion>
